
export const BASE_URL_API_TRANXT_UAT_API = `https://api.seobix.com`;

export const BASE_URL_API_BLOG = `https://blogapi.packky.com/api/Bumppy`;


